/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { MsalAuthProvider, AccessTokenResponse } from 'react-aad-msal';
import config from './authProviderConfig';
import options from './authenticationOptions';
import authenticationParameters from './authenticationParameters';

const { AUTH_METHOD, AUTH_STATIC_TOKEN } = window['env'];
const getAuthProvider = () => {
  let authProvider: MsalAuthProvider = new MsalAuthProvider(config, authenticationParameters, options);
  return authProvider;
};
export const getAuthToken = (): Promise<AccessTokenResponse> => {
  if (AUTH_METHOD === 'STATIC') {
    return Promise.resolve({
      accessToken: AUTH_STATIC_TOKEN
    } as AccessTokenResponse);
  } else {
    const provider = getAuthProvider();
    return provider.getAccessToken();
  }
};
export default getAuthProvider;
